import { Autocomplete } from '@mui/material';
import { useOldPetService } from 'service';

export default function SelectMemberGender(props) {
  const { usePetGenderOpts } = useOldPetService();
  const { data: petGenderData } = usePetGenderOpts();

  return <Autocomplete options={petGenderData || []} getOptionLabel={option => option.genderName} {...props} />;
}
